module.exports = __webpack_public_path__ + "img/list.ea07fb4a.svg";